import dayjs from '~/timeInit';

import type { PerformanceDateRange } from './types';

export function dateRangeError(range: PerformanceDateRange, reportDate: string): string | null {
  const valid = (value: string) =>
    /^\d{4}-\d{2}-\d{2}$/.test(value) && dayjs(value).isValid() && dayjs(value).format('YYYY-MM-DD') === value;
  if (!valid(range.start_date) || !valid(range.end_date)) return 'Choose a valid start and end date.';
  if (range.start_date > range.end_date) return 'The end date must be on or after the start date.';
  const earliest = dayjs(reportDate).subtract(89, 'day').format('YYYY-MM-DD');
  if (range.start_date < earliest || range.end_date > reportDate)
    return `Choose dates between ${earliest} and ${reportDate}.`;
  return null;
}
